import React from 'react';
export function TableHead({
  tableList,
  bool,
  oneMore,
  checkBoxes,
  checked,
  onCheck,
}: {
  tableList: string[];
  bool?: boolean;
  oneMore?: boolean;
  checkBoxes?: boolean;
  checked?: boolean;
  onCheck?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <thead className='bg-gray-50 table-fixed'>
      <tr>
        {tableList.map((t, index) => (
          <th
            key={t}
            scope='col'
            className='px-6 py-3 text-xs text-center font-medium text-gray-500 uppercase tracking-wider'
          >
            {checkBoxes && index === 0 ? (
              <div className='flex items-center w-full'>
                <div className='mr-2'>
                  <input
                    type='checkbox'
                    checked={checked}
                    onChange={onCheck}
                    className='h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500'
                  />
                </div>
                <div className='flex items-center justify-center gap-2'>
                  {t.split('_').join(' ').trim()}
                </div>
              </div>
            ) : (
              <div className='flex items-center justify-center gap-2'>
                {t.split('_').join(' ').trim()}
              </div>
            )}
          </th>
        ))}
        {oneMore && (
          <th
            scope='col'
            className='px-6 py-3 text-xs text-center font-medium text-gray-500 uppercase tracking-wider'
          ></th>
        )}
        {bool && (
          <th scope='col' className='relative px-6 py-3'>
            <span className='sr-only'>Edit</span>
          </th>
        )}
      </tr>
    </thead>
  );
}
